import { render } from "./AppMainBar.vue?vue&type=template&id=5ad66e7c&scoped=true"
import script from "./AppMainBar.vue?vue&type=script&lang=js"
export * from "./AppMainBar.vue?vue&type=script&lang=js"

import "./AppMainBar.vue?vue&type=style&index=0&id=5ad66e7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad66e7c"]])

export default __exports__